import React, {useState, ReactElement} from 'react';
import MidScreenModal, {
  ModalAnimateDirection,
} from '../../../components/modal/MidScreenModal';
import unlockOfferLockIcon from '../../../assets/images/unlock.svg';
import topNavOffersIcon from '../../../assets/images/top_nav_offers_small.svg';
import moment from 'moment';

enum SlideDirection {
  RIGHT,
  LEFT,
  NONE,
}

type offerType = {
  customerCouponId: number;
  mobileNumber: string;
  couponGeneratedTime: string;
  couponCode: string;
  description: string;
  validity: string;
  keyId: string;
  couponType: string;
  regionId: string;
  detailsId: number;
};

type OfferType = {
  onClose: () => void;
  open?: boolean;
};

const Offer = ({onClose, open}: OfferType): ReactElement => {
  const getValidity = (validity: string | undefined) => {
    return moment(validity).format('DD MMM YYYY');
  };

  const [animateStyles, setAnimateStyles] = useState<any>({});

  return (
    <MidScreenModal
      isVisible={open}
      onClose={onClose}
      animate={true}
      animateDirection={ModalAnimateDirection.RIGHT_TO_LEFT}>
      <div className="overflow-x-hidden p-4">
        <div
          className={`transition transform views-wrapper`}
          style={{...animateStyles}}>
          {/* style={{...animateStyles}}> */}
          <div className="">
            <OfferView
              onTncClick={
                () => console.log('clicked')
                //setAnimateStyles({'--tw-translate-x': '-20rem'})
              }
            />
          </div>
        </div>
      </div>
    </MidScreenModal>
  );
};

interface OfferViewProps {
  animationDirection?: SlideDirection;
}

const OfferView = ({
  animationDirection = SlideDirection.NONE,
}: OfferViewProps): ReactElement => {
  const animateClasses: string =
    animationDirection == SlideDirection.NONE
      ? ''
      : animationDirection == SlideDirection.LEFT
      ? 'animate__slideOutLeft'
      : 'animate__slideInLeft';

  return (
    <div
      className={`w-72 offer-view flex flex-col items-center justify-center`}>
      <div className="">
        <img src={unlockOfferLockIcon}></img>
        {/* <div className="text-base font-bold">{offer?.type}</div> */}
        {/* <div className="text-sm mt-0.5">{offer?.discount}</div> */}
      </div>
      <div className="mt-5 w-full">
        <div className="text-xl">Awesome</div>
        <div className="font-bold font-roboto  flex justify-center">
          <span>You got a new offer</span>
          <span>
            <img src={topNavOffersIcon} />
          </span>
        </div>
        <div className="mt-4 mb-2">
          Please check the details at My offer Page
        </div>
      </div>
      {/* <div className=" mt-5 text-red-600 font-roboto font-bold">T&C Apply</div> */}
    </div>
  );
};

export default Offer;
